const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '基本信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '中标候选人',
        },
    },
    {
        component: 'ZlmTabDetail',
        options: {
            title: '候选人',
            data: [],
        },
    },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/gt-jy-jianguan/api/zbjggs/ZbjggsInfoView.do`, {
                bdGuid: this.form.bdGuid,
            }, { showLoading: true }).then((res) => {
                this.config[1].options.data = {
                    '标段/包名称': res.data.rows.bdName,
                    '标段/包编号': res.data.rows.bdBH,
                    '项目类型': getProjectTypeName(res.data.rows.zbxmlx),
                    '采购方式': getPurchaseTypeName(res.data.rows.cgFangShi),
                    '供应商总数': res.data.rows.gysCount,
                    '中标供应商': res.data.rows.zbgysCount,
                }
                if (res.data && res.data.rows.jggsList) {
                    this.config[3].options.data = res.data.rows.jggsList.map((t) => ({
                            '中标候选人': t.tbrName,
                            '是否中标': t.isZhongBiao ? '是' : '否',
                        }))
                }
            })
        },
        pass() {
            this.commit()
        },
        fail(opinion) {
            this.commit({
                opValue: '2', // 不通过
                opinion: opinion,
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
